export const enContent = {
  code: 'EN',
  locale: 'en-US',
  nav: {
    about: 'About Us',
    atms: 'ATMs',
    services: 'Services',
    partner: 'Become a Partner',
    search: 'Search',
  },
  common: {
    home: 'Home',
    learnMore: 'Learn More',
    viewServices: 'View Services',
    back: 'Back',
    regulated: 'FINBOX CJSC is regulated by the Central Bank of the Republic of Armenia.',
    address: '2/4 Maro Margaryan St., Yerevan',
    contact: 'Contact Us',
    general: 'General',
    information: 'Information',
    country: 'Armenia',
    copyrightName: 'FINBOX CJSC',
  },
  home: {
    eyebrow: 'INDEPENDENT ATM NETWORK',
    title: 'The first and only independent ATM network in Armenia.',
    lead: 'FINBOX is transforming Armenia\'s payment and settlement market by making cash withdrawals simpler.',
    visionTitle: 'Our Vision',
    vision: 'To provide the Armenian market with innovative financial products and a modern network of self-service centers, saving customers time when making cash and cashless transactions.',
    valuesTitle: 'Our Values',
    values: [
      ['Integrity and Transparency', 'We serve all financial institutions on equal terms, building trust and security.'],
      ['Development', 'We invest in advanced financial technologies and adapt the world\'s best practices to the local market.'],
      ['People', 'Our customers, professional team, and trusted partners are our greatest values.'],
    ],
    servicesTitle: 'Financial Services in One Network',
    servicesLead: 'From cash withdrawals to payments for more than 400 services.',
    services: [
      ['ATMs', 'Activate your card, change your PIN, check your balance, withdraw cash, and make transfers.', 'landmark'],
      ['Terminals', 'Payments, transfers, and technical solutions designed for your business.', 'panels-top-left'],
      ['400+ Services', 'Utility, government, banking, lending, insurance, and other payments.', 'badge-check'],
    ],
    ctaTitle: 'Become a FINBOX Partner',
    ctaText: 'Join an independent financial network and help expand access to financial services throughout Armenia.',
  },
  about: {
    title: 'About Us',
    intro: 'FINBOX CJSC combines traditional payment and settlement instruments with innovative fintech solutions to deliver high-quality, modern services.',
    missionTitle: 'Our Mission',
    mission: 'To improve operational efficiency and reliability by implementing advanced self-service financial technologies.',
    goalTitle: 'Our Goal',
    goal: 'To become Armenia\'s national leader in payment and settlement operations. By expanding our self-service network throughout the country, we aim to make financial services accessible to everyone.',
  },
  atms: {
    title: 'With a FINBOX ATM, You Can:',
    intro: 'Secure and accessible self-service transactions in a few simple steps.',
    items: [
      ['Activate Your Card', 'Insert your card, select “Card Activation,” enter the code sent to the phone number registered with your bank, and set a PIN that is convenient for you.'],
      ['Change Your Card PIN', 'Insert your card, select “Additional Services,” then “Change PIN.” Enter your current PIN and set a new one.'],
      ['Withdraw Cash and Check Your Balance', 'Use the ATM to check your card balance and withdraw cash by entering an amount manually or selecting one of the suggested amounts.'],
      ['Make Card-to-Card Transfers', 'Select “Card-to-Card Transfer,” enter the recipient\'s card number and the transfer amount. The transfer is completed within seconds.'],
      ['Get a Statement of the Latest 7 Pension Account Credits', 'Select “Pension Statement” under “Additional Services.” The ATM will print the statement as a receipt.'],
      ['Get a Statement of the Latest 12 Unsettled Transactions', 'Select “Unsettled Transactions” under “Additional Services” to receive a printed statement of transactions that have not yet been charged.'],
    ],
  },
  faq: {
    title: 'Frequently Asked Questions',
    intro: 'Quick answers about FINBOX ATMs and terminals.',
    items: [
      ['Where can I find FINBOX ATMs and terminals?', 'FINBOX ATMs and terminals are installed at convenient locations in Yerevan and Armenia\'s regions, including retail chains, markets, shopping centers, stores, bank and corporate offices, and recreation areas.'],
      ['Which services can I pay for through FINBOX terminals?', 'FINBOX terminals accept payments for more than 400 services. The full list is available on the Services page.'],
      ['Which payment methods do FINBOX terminals accept?', 'You can make payments of up to AMD 50,000 using all banknote denominations, as well as AMD 100, 200, and 500 coins.'],
    ],
  },
  partner: {
    title: 'Become a Partner',
    intro: 'Complete the required fields, and our team will contact you to discuss partnership opportunities.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    message: 'Message',
    send: 'Send',
    required: 'This field is required.',
    invalidEmail: 'Enter a valid email address.',
    ready: 'Your message is ready to be sent through your email application.',
  },
  mediator: {
    title: 'Financial System Mediator',
    addressLabel: 'Address',
    address: '15 M. Khorenatsi St., Elite Plaza Business Center, 7th Floor, Yerevan 0010, Republic of Armenia',
    phone: 'Phone: (+374 60) 70-11-11',
    fax: 'Fax: (+374 10) 58-24-21',
    hoursTitle: 'Business Hours',
    hours: 'Monday-Friday: 9:00-18:00; lunch break: 13:00-14:00. The complaints and claims team also works during the lunch break.',
    website: 'Website',
  },
  services: {
    title: 'Payment Services',
    intro: 'Payment services available 24 hours a day.',
    bankTitle: 'Banks - Tariffs',
    cashInTitle: 'Cash-in tariffs',
    cashOutTitle: 'Cash-out tariffs',
    cashOutDescription: 'Cash withdrawal tariffs',
    cashOutIntro: 'Cash withdrawal tariffs by card issuer.',
    cashOutTableLabel: 'Cash-out tariff table',
    cashOutBankColumn: 'Bank',
    cashOutTypeColumn: 'Type',
    cashOutFinboxCommissionColumn: 'FINBOX commission',
    cashOutIssuerConditionsColumn: 'Issuing bank conditions',
    cashOutIssuerConditions: 'Issuing bank conditions',
    cashOutExternalLinkLabel: 'open issuing bank conditions in a new tab',
    cashOutAmeriaCommission: 'AMD 500 / transaction',
    cashOutInternationalBankCards: 'International bank cards',
    cashOutVmExplanation: 'Visa / Mastercard',
    cashOutInternationalConditions: 'Subject to the issuing bank’s conditions',
    cashOutFeaturedTitle: 'Converse Bank and Evocabank',
    cashOutOtherBanksTitle: '15 banks',
    arcaCardsTitle: 'ARCA Cards',
    arcaCardsDescription: 'Cards issued within the ARCA payment system',
    comingSoon: 'Coming soon',
    bankDescription: '17 banks',
    cardRefillTitle: 'Visa / Mastercard Payments',
    cardRefillIntro: 'General card replenishment tariffs.',
    accountRefillTitle: 'Account Replenishment',
    accountRefillIntro: 'General bank account replenishment tariffs.',
    chooseTariff: 'View Tariffs',
    bank: 'Bank',
    bankListIntro: 'Select the bank you need.',
    more: 'Learn More',
    code: 'Code',
    detailIntro: 'Payment types, fees, and transaction limits.',
    paymentTypes: ['Bank Account Top-Up', 'Card Top-Up', 'Loan Repayment', 'Account Top-Up', 'Card Top-Up'],
    feeModel: 'Fee Schedule',
    feeTiers: ['AMD 1,000-20,000: AMD 200', 'AMD 20,001-50,000: AMD 300', 'AMD 50,001-100,000: AMD 400', 'AMD 100,001-400,000: 0.5%'],
    minimumFee: 'Minimum Fee',
    maximumTransaction: 'Maximum Transaction',
    paymentType: 'Payment Type',
    commission: 'Fee',
    limit: 'Limit',
    standardFee: 'Standard A',
    amd: 'AMD',
  },
  reports: {
    title: 'Reports',
    intro: 'Annual Financial Reports',
    pending: 'The PDF has not been uploaded yet',
    download: 'Download PDF',
    items: [
      { year: 2025, fileName: 'FINBOX_2025_Arm.pdf', size: '4.3 MB', url: '/assets/reports/FINBOX_2025_Arm.pdf' },
      { year: 2024, fileName: 'FINBOX_2024_Arm.pdf', size: '14.7 MB', url: '/assets/reports/FINBOX_2024_Arm.pdf' },
    ],
  },
  consumerRights: {
    title: 'Consumer Rights',
    intro: 'Information on complaints, applications, and consumer protection.',
    documentsTitle: 'Regulatory Documents',
    documentsIntro: 'Approved FINBOX documents will be published here.',
    documents: ['Procedure for Reviewing Complaints and Applications', 'Procedure for Submitting Complaints and Applications'],
    pending: 'Document to be added',
    paragraphs: [
      'Complaints and applications submitted to FINBOX CJSC are reviewed and answered in accordance with the company\'s approved internal procedures.',
      'The terms governing FINBOX CJSC services and payment acceptance are available in the website\'s',
    ],
    acceptedTitle: 'Complaints and applications are accepted via:',
    responseNote: 'Response timeframes and procedures will be published together with the relevant regulatory documents.',
  },
  usefulLinks: {
    title: 'Useful Links',
    intro: 'Official and informational resources for Armenia\'s financial system.',
    items: [
      ['Central Bank of Armenia', 'Official website of the Central Bank of the Republic of Armenia', 'https://www.cba.am/'],
      ['Financial System Mediator', 'Financial dispute resolution and consumer protection service', 'https://fsm.am/'],
      ['Fininfo', 'Financial services information and comparison platform', 'https://www.fininfo.am/'],
      ['ABC Finance', 'Financial education platform', 'https://abcfinance.am/'],
      ['ArCa', 'Online services of the Armenian Card payment system', 'https://cabinet.arca.am/'],
    ],
    disclaimer: 'FINBOX CJSC is not responsible for the accuracy of content available through external links published on this website or for any consequences arising from its use.',
  },
  cookiePolicy: {
    title: 'Cookie Policy',
    intro: 'Information about the potential use of cookies and similar technologies on this website.',
    contentsTitle: 'Contents',
    opening: [
      'FINBOX CJSC may use cookies and similar traffic-recording technologies on its official atm.finbox.am website and related digital services to operate and personalize the website and improve service quality.',
      'The Company reserves the right to amend this policy. The latest version is published on the website and takes effect upon publication. Users are encouraged to review this policy periodically.',
    ],
    sections: [
      { title: 'Purpose of Cookies', paragraphs: ['A cookie is a small data file that a website stores on a user\'s device. It may contain a unique identifier and be sent back to the website during subsequent visits.', 'Cookies may retain session status, preferences, information about features used, and technical information about pages viewed.'] },
      { title: 'Managing Cookies', paragraphs: ['Most browsers accept cookies automatically. Users can remove or block cookies through their browser settings.', 'Restricting cookies may affect the availability or operation of certain website features.'] },
      { title: 'Advertising and Analytics Cookies', paragraphs: ['When used, advertising cookies help display more relevant content and measure how frequently advertisements are viewed.', 'Analytics cookies provide information about navigation paths, page interactions, and the most frequently used features to help improve the website.'] },
      { title: 'Personalization and Security Cookies', paragraphs: ['Personalization cookies may recognize repeat visits and retain user settings and preferences.', 'Security cookies are used to detect security risks, authenticate users, and protect data from unauthorized access.'] },
      { title: 'Website Management Cookies', paragraphs: ['Website management cookies may retain login status, session progress, and technical data entered on pages so that activity is not unexpectedly interrupted.', 'These cookies are generally managed as a single functional group and may be required for the website\'s core operation.'] },
    ],
  },
  search: {
    title: 'Search',
    intro: 'Search the website\'s pages and services.',
    placeholder: 'Enter a search term',
    empty: 'Start typing to see results.',
    noResults: 'No results found.',
  },
  offer: {
    title: 'Public Offer',
    item: 'Public Offer 2025',
    open: 'View Original',
  },
  atmMap: {
    title: 'Find the Nearest FINBOX ATM',
    intro: 'Select a location to view it on the map.',
    count: ' locations',
    route: 'Get Directions',
    locations: [
      { name: 'Voskevaz', address: '17 Araratyan St.' },
      { name: 'Yerevan', address: '35 Movses Khorenatsi St.' },
    ],
  },
  ui: {
    mainNavigation: 'Main navigation',
    menu: 'Menu',
    pageNotFound: 'Page not found',
    atmLabel: 'FINBOX ATM',
    atmServiceImageAlt: 'FINBOX ATM services',
    factsLabel: 'FINBOX facts',
    teamImageAlt: 'FINBOX team',
    partnershipImageAlt: 'FINBOX partnership',
    partnerEmailSubject: 'FINBOX partnership request',
    formName: 'Name',
    formEmail: 'Email',
    formPhone: 'Phone',
  },
};
